import * as z from 'zod/mini';
import isNotUndefinedString from '@/utility/isNotUndefinedString';

const asArray = <T extends z.ZodMiniType>(type: T) =>
  z.transform((value: unknown) => {
    if (Array.isArray(value)) return value.map((el) => type.parse(el));
    if (typeof value === 'string' && value.includes(',')) {
      return value.split(',').map((el) => type.parse(el.trim()));
    }
    return [type.parse(value)];
  });

export const optional = <T extends z.ZodMiniType>(type: T) => z.catch(z.optional(type), undefined);

export const optionalStringArray = optional(
  asArray(z.string().check(z.refine(isNotUndefinedString)))
);

export const optionalStringBoolean = optional(
  z.transform((val) => String(val).toLowerCase() === 'true')
);

export const optionalString = optional(z.string());
